import React from "react";
import { CircularProgress } from "@mui/material";
import "./Button.styles.scss";

export interface ButtonProps {
  children?: JSX.Element | string | (JSX.Element | string)[];
  title?: string;
  variant?:
    | "primary"
    | "primary-light-border"
    | "light"
    | "gray"
    | "square"
    | "square-light-border"
    | "oval-border"
    | "gold"
    | "primary-white"
    | "light-border"
    | "primary-success";
  size?: "small" | "normal" | "large";
  onClick?: () => void | Promise<void>;
  type?: "button" | "reset" | "submit";
  disabled?: boolean;
  className?: string;
  isLoading?: boolean;
  dataTestId?: string;
}

export const Button: React.FC<ButtonProps> = ({
  children,
  title = "",
  variant = "primary",
  size = "normal",
  onClick = () => {},
  type = "button",
  disabled = false,
  className = "",
  isLoading = false,
  dataTestId = ""
}) => {
  return (
    <button
      data-testid={dataTestId}
      disabled={disabled}
      type={type}
      onClick={isLoading || disabled ? () => {} : onClick}
      className={`one-row-text button button-${variant} button-${size} button${disabled ? "--disabled" : ""} 
        ${disabled ? "" : "scale-click"} flex-fc-fc ${className}`}
    >
      <div hidden={!isLoading} className="button__spinner">
        <CircularProgress size={20} />
      </div>
      {children ? children : title}
    </button>
  );
};
